import { css, Theme, Interpolation } from "@emotion/react";

type Props = {
  title?: string;
  comment: string;
  profile: string;
  wrapperStyle?: Interpolation<Theme>;
};

const CommentItem: React.FC<Props> = (props) => {
  const { title, comment, profile, wrapperStyle } = props;

  return (
    <div css={[mainStyle, wrapperStyle]}>
      {title && <div css={titleStyle}>{title}</div>}
      <div css={commentStyle({ fontSize: 15.5, spFontSize: 12 })}>
        {comment}
      </div>
      <div
        css={commentStyle({ paddingTop: 36, spPaddingTop: 18, spFontSize: 11 })}
      >
        {profile}
      </div>
    </div>
  );
};

const spSize = 768;

const mainStyle = css`
  width: 100%;
  max-height: 500px;
  padding: 10px 15px 20px;
  background-color: rgba(255, 255, 255, 0.2);
  display: flex;
  flex-direction: column;
  align-items: start;
  box-sizing: border-box;

  @media (max-width: ${spSize}px) {
    padding: 10px;
    max-height: 250px;
    overflow-y: scroll;

    &::-webkit-scrollbar {
      width: 7px;
    }
    &::-webkit-scrollbar-track {
      background-color: rgba(255, 255, 255, 0.2);
    }
    &::-webkit-scrollbar-thumb {
      background-color: rgba(255, 255, 255, 0.5);
    }
    scrollbar-width: 7px;
    scrollbar-color: rgba(255, 255, 255, 0.5) rgba(255, 255, 255, 0.2);
  }
`;

const titleStyle = css`
  font-size: 20px;
  fotn-weight: 500;

  @media (max-width: ${spSize}px) {
    font-size: 16px;
  }
`;

const commentStyle = ({
  fontSize,
  spFontSize,
  paddingTop,
  spPaddingTop,
}: {
  fontSize?: number;
  spFontSize?: number;
  paddingTop?: number;
  spPaddingTop?: number;
}) => css`
  padding-top: ${paddingTop ?? 12}px;
  font-size: ${fontSize ?? 14}px;
  white-space: pre-wrap;
  text-align: left;

  @media (max-width: ${spSize}px) {
    font-size: ${spFontSize ?? 12.5}px;
    padding-top: ${spPaddingTop ?? 10}px;
  }
`;

export default CommentItem;
